import React from 'react';
const ProgressBar = (props) => {

    return (
        props.progress !== 0 &&
        <div style={{
            marginLeft: '5px',
            height: '25px',
            border: '1px solid gray',
            backgroundColor: 'lightgrey'
        }}
            class="ra-input" >
            <div
                style={{
                    backgroundColor: '#36ADF2',
                    display: 'flex',
                    flexDirection: 'column',
                    fontSize: '0.9em',
                    fontWeight: '500',
                    fontFamily: 'verdana',
                    width: `${props.progress * 100}%`,
                    color: 'white',
                    height: '100%',
                    textAlign: 'end'
                }} >{Math.floor(props.progress * 100)}%</div>
        </div>)
}
export default ProgressBar